import React from "react";
import FeaturesTiles from "../components/sections/FeaturesTiles";
import '../App.css'

function Skills() {
  return (
    <div className="fade-in">
      <FeaturesTiles  topDivider/>
    </div>
  );
}

export default Skills;
